module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#longform",
      toString: function () {
        return this.url;
      }
    }